import { HEADER_URL } from 'constants/app';

// My Swisscom Business header/footer
if (HEADER_URL) {
  const script = document.createElement('script');
  script.src = HEADER_URL;
  script.type = 'module';
  document.head.appendChild(script);
}
